import { createSelector } from 'reselect';
import { AppState } from 'store';
import { DataTypeName, DocumentTypeName, ResultTypeName } from '.';

export const showReferencesSelector = createSelector(
  (state: AppState) => state.search,
  (search) =>
    (
      dataTypeName: DataTypeName,
      documentType: DocumentTypeName,
      resultItemIndex: number,
      resultType: ResultTypeName,
    ) => {
      switch (dataTypeName) {
        case 'propertyData': {
          const showReferences =
            // @ts-ignore:
            search?.propertyData?.results?.find(
              (result) => result.index === resultItemIndex,
            )[documentType].showReferences;
          return showReferences;
        }
        case 'nameData': {
          const showReferences =
            // @ts-ignore:
            search?.nameData?.results?.find(
              (result) => result.index === resultItemIndex,
            )[documentType].showReferences;
          return showReferences;
        }
        case 'multiData': {
          switch (resultType) {
            case 'propertyResult': {
              const showReferences =
                // @ts-ignore:
                search?.multiData?.propertyResult?.results?.find(
                  (result) => result.index === resultItemIndex,
                )[documentType].showReferences;
              return showReferences;
            }
            case 'nameResult': {
              const showReferences =
                // @ts-ignore:
                search?.multiData?.nameResult?.results.find(
                  (result) => result.index === resultItemIndex,
                )[documentType].showReferences;
              return showReferences;
            }
          }
        }
      }
    },
);

export const exportTypeSelector = createSelector(
  (state: AppState) => state.search,
  (search) =>
    (
      dataTypeName: DataTypeName,
      documentType: DocumentTypeName,
      resultItemIndex: number,
      resultType: ResultTypeName,
    ) => {
      switch (dataTypeName) {
        case 'propertyData': {
          // @ts-ignore:
          return search?.propertyData?.results?.find(
            (result) => result.index === resultItemIndex,
          )[documentType].exportType;
        }
        case 'nameData': {
          const exportType =
            // @ts-ignore:
            search?.nameData?.results?.find(
              (result) => result.index === resultItemIndex,
            )[documentType].exportType;
          return exportType;
        }
        case 'multiData': {
          switch (resultType) {
            case 'propertyResult': {
              // @ts-ignore:
              return search?.multiData?.propertyResult?.results?.find(
                (result) => result.index === resultItemIndex,
              )[documentType].exportType;
            }
            case 'nameResult': {
              const exportType =
                // @ts-ignore:
                search?.multiData?.nameResult?.results?.find(
                  (result) => result.index === resultItemIndex,
                )[documentType].exportType;
              return exportType;
            }
          }
        }
      }
    },
);

export const isSelectedSelector = createSelector(
  (state: AppState) => state.search,
  (search) =>
    (
      dataTypeName: DataTypeName,
      documentType: DocumentTypeName,
      guid: string,
      resultItemIndex: number,
      resultType: ResultTypeName,
    ) => {
      switch (dataTypeName) {
        case 'propertyData': {
          const { isSelected } =
            // @ts-ignore:
            search?.propertyData?.results
              ?.find((result) => result.index === resultItemIndex)
              [documentType].items?.find((item: any) => item.guid === guid);
          return isSelected;
        }
        case 'otherData': {
          // @ts-ignore:
          const { isSelected } =
            // @ts-ignore:
            search?.otherData?.results
              ?.find(
                (result) =>
                  result.index === resultItemIndex &&
                  result.searchBy === documentType,
              )
              // @ts-ignore:
              ?.items?.find((item) => item.guid === guid);
          return isSelected;
        }
        case 'nameData': {
          if (search?.nameData && resultItemIndex >= 0) {
            return (
              // @ts-ignore:
              search.nameData.results
                ?.find((result) => result.index === resultItemIndex)
                [documentType].items.find((x: any) => x.guid === guid)
                .isSelected
            );
          }
          return false;
        }
        case 'multiData': {
          switch (resultType) {
            case 'propertyResult': {
              const { isSelected } =
                // @ts-ignore:
                search?.multiData?.propertyResult?.results
                  ?.find((result) => result.index === resultItemIndex)
                  [documentType].items?.find((item: any) => item.guid === guid);
              return isSelected;
            }
            case 'otherResult': {
              // @ts-ignore:
              const { isSelected } =
                // @ts-ignore:
                search?.multiData?.addressResult?.results
                  ?.find(
                    (result) =>
                      result.index === resultItemIndex &&
                      result.searchBy === documentType,
                  )
                  // @ts-ignore:
                  ?.items?.find((item) => item.guid === guid);
              return isSelected;
            }
            case 'nameResult': {
              if (search.multiData?.nameResult && resultItemIndex >= 0) {
                return (
                  // @ts-ignore:
                  search.multiData?.nameResult.results
                    .find((result) => result.index === resultItemIndex)
                    [documentType].items.find((x: any) => x.guid === guid)
                    .isSelected
                );
              }
              return false;
            }
          }
        }
      }
    },
);
